import styled from "styled-components";

export const ListContainer = styled.div.attrs({})`
  position: relative;
  overflow: hidden;
  flex: 1 1 calc((100% - 12px) / 2);
  width: 100%;
  min-width: min(100%, 360px);
  padding: 10px 14px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 18px;
  cursor: pointer;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  box-shadow: 0 18px 42px ${p => p.theme.palette.colors.shadowStrong};
  transition: transform 0.22s ease, box-shadow 0.22s ease;

  &:focus-visible {
    outline: 2px solid ${p => p.theme.palette.blue.main};
    outline-offset: 3px;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 24px 52px ${p => p.theme.palette.colors.shadowLift};
  }

  @media(max-width: 720px) {
    flex-basis: 100%;
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const FavoriteAction = styled.button.attrs({
  type: 'button',
})`
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => p.theme.palette.colors.surfaceElevatedStrong};
  box-shadow: 0 10px 24px ${p => p.theme.palette.colors.shadowStrong};
  cursor: pointer;
  flex-shrink: 0;
`;

export const ListWrapper = styled.div.attrs({})`
  min-width: 0;
  flex: 1 1 auto;
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const Thumbnail = styled.div.attrs({})`
  position: relative;
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 14px 32px ${p => p.theme.palette.colors.shadowStrong};
`;

export const ImgCover = styled.img.attrs({})`
  width: 54px;
  height: 54px;
  max-height: 100%;
  object-fit: contain;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
  pointer-events: none;
  border-radius: inherit;
`;

export const CardTitle = styled.div.attrs({})`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-family: Gilroy;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: ${p => p.theme.palette.colors.text};
`;

export const CardMeta = styled.div.attrs({})`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
`;

export const ItemType = styled.div.attrs({})`
  min-height: 20px;
  border-radius: 999px;
  padding: 3px 8px;
  background: ${p => p.theme.palette.colors.badgeMuted};
  color: ${p => p.theme.palette.colors.text};
  font-family: Poppins;
  font-size: 13px;
  line-height: 1.35;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
`;

export const ShareContainer = styled.div.attrs({})`
  display: flex;
  align-items: center;
`;

export const Container = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex: 0 0 auto;
  min-width: 0;
  ${p => p.column ? `
    width: 100%;
    min-width: 0;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  ` : ''};

  @media(max-width: 720px) {
    ${p => !p.column ? `
      width: 100%;
      justify-content: flex-start;
      flex-wrap: wrap;
    ` : ''};
  }
`;
